import { useTheme } from '@emotion/react';
import React, { useCallback } from 'react';

import { Button, Icon, Text } from '~/components/blocks';

type Props = {
  pharmacyId: string;
  patientCode: string;
};

export const OpenButton = (props: Props) => {
  const theme = useTheme();
  const { pharmacyId, patientCode } = props;

  const handleOpenMedixs = useCallback(() => {
    window.open(
      `${process.env.medixsRootUrl}/history/by_patient_code/${pharmacyId}/${patientCode}`,
      '_blank',
      'noopener,noreferrer',
    );
  }, [patientCode, pharmacyId]);

  return (
    <Button
      size="ms"
      padding={`1px ${theme.space.m}`}
      marginRight={theme.space.s}
      onClick={handleOpenMedixs}
    >
      <Icon size="s" icon="blank" color="blue" />
      <Text size="xs">薬歴</Text>
    </Button>
  );
};
